import React from 'react';
import styled from 'styled-components';
import NbPointOfSalesMacaron from 'assets/images/nb_point_of_sales.svg';

const MacaronContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  .last-market-online-nb-restaurant-label {
    position: absolute;
    top: 40px;
    font-size: 26px;
    color: white;
  }
`;

const Macaron = ({ nbRestaurants }) => (
  <MacaronContainer>
    <img src={NbPointOfSalesMacaron} alt="Meilleure note" className="macaron" />
    <p className="last-market-online-nb-restaurant-label">{nbRestaurants}</p>
  </MacaronContainer>
);

export default Macaron;
